import { ACTIONS } from '../utils/constants';

const {
  SET_IS_DIRTY,
  SET_QUIZ_TITLE,
  ADD_QUESTIONS_TO_QUIZ,
  RESET_QUIZ,
  SET_NEW_QUIZ,
  SET_MY_QUIZ,
  SET_ACTIVE_STIMULUS_FILTERS,
  SET_LOADED_DATA,
  CLOSE_AND_RESET_QUIZ,
  SAVE_QUIZ,
  UPDATE_ITEM_USAGE,
  ROLLBACK_QUIZ,
  SET_SUBJECT_INFO,
  SET_ACTIVE_TAB,
  SET_LOADING_QUIZ,
} = ACTIONS;

export const setIsDirty = (dispatch, isDirty) =>
  dispatch({
    type: SET_IS_DIRTY,
    payload: { isDirty },
  });

export const setQuizTitle = (dispatch, quizTitle) =>
  dispatch({
    type: SET_QUIZ_TITLE,
    payload: { quizTitle },
  });

export const addQuestionsToQuiz = (
  dispatch,
  libraryId,
  myQuizIds,
  questions,
  stimuli,
  stimuliQuestions,
) =>
  dispatch({
    type: ADD_QUESTIONS_TO_QUIZ,
    payload: {
      libraryId,
      myQuizIds,
      questions,
      stimuli,
      stimuliQuestions,
    },
  });

export const resetQuiz = (dispatch) =>
  dispatch({
    type: RESET_QUIZ,
  });

export const rollbackQuiz = (dispatch) =>
  dispatch({
    type: ROLLBACK_QUIZ,
  });

export const setNewQuiz = (
  dispatch,
  quizTitle,
  quizId,
  activeTab = null,
  libraryId,
) =>
  dispatch({
    type: SET_NEW_QUIZ,
    payload: { quizTitle, quizId, activeTab, libraryId },
  });

export const setMyQuiz = (dispatch, myQuiz, stimulusQuestionsInQuiz) =>
  dispatch({
    type: SET_MY_QUIZ,
    payload: {
      myQuiz,
      stimulusQuestionsInQuiz,
    },
  });

export const setActiveStimulusFilters = (dispatch, activeStimulusFilters) =>
  dispatch({
    type: SET_ACTIVE_STIMULUS_FILTERS,
    payload: {
      activeStimulusFilters,
    },
  });

export const setLoadedData = (
  dispatch,
  itemsColumns,
  items,
  addAllItemIds,
  courseOutlineConfig,
) =>
  dispatch({
    type: SET_LOADED_DATA,
    payload: {
      itemsColumns,
      items,
      addAllItemIds,
      courseOutlineConfig,
    },
  });

export const closeAndResetQuiz = (dispatch) =>
  dispatch({
    type: CLOSE_AND_RESET_QUIZ,
  });

export const saveQuiz = (dispatch) =>
  dispatch({
    type: SAVE_QUIZ,
  });

export const updateItemUsage = (
  dispatch,
  { checkAll = false, remove = false } = {},
) =>
  dispatch({
    type: UPDATE_ITEM_USAGE,
    payload: {
      updateItemUsageCheckAll: checkAll,
      updateItemUsageRemove: remove,
    },
  });

export const setLoadingQuiz = (dispatch, payload) =>
  dispatch({
    type: SET_LOADING_QUIZ,
    payload,
  });

export const setSubjectInfo = (dispatch, payload) =>
  dispatch({
    type: SET_SUBJECT_INFO,
    payload,
  });

export const setActiveTab = (dispatch, activeTab) =>
  dispatch({
    type: SET_ACTIVE_TAB,
    payload: { activeTab },
  });
